/* eslint-disable no-restricted-syntax */
import { useQuery } from '@tanstack/react-query';
import { getEmployeeOnschedResource } from '../../services/employee';
import { EmployeesResourceMap } from '../../types/employees';
import { LoadedUser } from '../../interfaces';
import useUser from '../global/useUser';

function useOnschedResourceBatch({ employeeIds }: { employeeIds: string[] }) {
  const { user: loadedUser } = useUser<LoadedUser>();

  const sortedIds = employeeIds?.sort();

  return useQuery<EmployeesResourceMap>({
    queryKey: ['employee-onsched-resource-batch', sortedIds, sortedIds?.length],
    queryFn: async () => {
      if (!sortedIds?.length) return {};
      const map: EmployeesResourceMap = {};

      // We need to append our DB timezone to the resource. Onsched's timezoneOffset is stale and doesn't shift during daylight savings.
      const employeeTimezones = loadedUser.business.employees.reduce(
        (acc, employee) => {
          if (employee.user) {
            acc[employee.employeeId] = employee.user.timezone;
          }
          return acc;
        },
        {} as Record<string, string | undefined>,
      );

      for (const employeeId of sortedIds) {
        try {
          const response = await getEmployeeOnschedResource(employeeId);
          map[employeeId] = {
            ...response,
            userDbTimezone: employeeTimezones[employeeId] || null,
          };
        } catch {
          // EMPTY
        }
      }
      const allFailed = Object.values(map).every(value => !value);
      if (allFailed) throw new Error('Failed to fetch all resources');
      return map;
    },
    retry: 1,
  });
}

export default useOnschedResourceBatch;
